module.exports = __webpack_public_path__ + "static/media/ic_categories_fashion.6934a0b8.svg";